import axios from "axios";
import { FamilyRequest, FamilyResponse, FamilyUpdateRequest } from "../types/FamilyTypes";
import axiosInstance from "./axiosInstance";

const API_URL = process.env.REACT_APP_API_URL;

export const getFamilies = async (): Promise<FamilyResponse[]> => {
    try {
        const response = await axiosInstance.get(`${API_URL}/families`, {
            withCredentials: true,
          });
        return response.data;
    } catch (error) {
        console.error("Error fetching messages:", error);
        return [];
    }
};

export const addFamily = async (familyData: FamilyRequest): Promise<any | null> => {
    if (!familyData) return;
    try {
       
        const response = await axiosInstance.post(`${API_URL}/families`, familyData, {
            withCredentials: true,
        });
        return response.data;        
    } catch (error) {
      console.error("Error adding family:", error);
      return null;
    }
  };

export const deleteFamily = async (id: number): Promise<void> => {
    try {
        await axiosInstance.delete(`${API_URL}/families/?id=${id}`, {
            withCredentials: true,
          });
    } catch (error) {
        console.error("Error deleting family:", error);
    }
};

export const getFamilyById = async (id: string): Promise<FamilyUpdateRequest | null> => {
    try {
      const response = await axiosInstance.get<FamilyUpdateRequest>(`${API_URL}/families/${id}`, {
          withCredentials: true,
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching family:", error);
      return null;
    }
  }

  export const updateFamily = async (request: FamilyUpdateRequest) => {
    try {
      const response = await axiosInstance.put(`${API_URL}/families`, request, {
        withCredentials: true,
      });
  
      return response.data;
    } catch (error) {
      console.error("Error updating families:", error);
      return null;
    }
  }
